(() => {
  const active = new Map();

  function mount(root) {
    if (!root || active.has(root)) return;

    const section = root.closest('.shopify-section');
    if (!section) return;

    let frame = 0;

    const sectionStart = () => {
      let top = 0;
      let node = section;
      while (node) {
        top += node.offsetTop || 0;
        node = node.offsetParent;
      }
      return top;
    };
    const start = sectionStart();

    const draw = () => {
      frame = 0;
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      const stage = root.querySelector('.oms-stage');
      const distance = Math.max(1, stage?.offsetHeight || root.offsetHeight || window.innerHeight);
      const passed = Math.max(0, window.scrollY - start);
      const progress = Math.min(1, passed / distance);
      const travel = mobile ? 58 : 96;

      root.style.setProperty('--oms-image-y', `${(progress * travel).toFixed(2)}px`);
      root.dataset.parallaxProgress = progress.toFixed(3);
      root.dataset.parallaxActive = 'true';
    };

    const requestDraw = () => {
      if (!frame) frame = requestAnimationFrame(draw);
    };

    window.addEventListener('scroll', requestDraw, { passive: true });
    window.addEventListener('resize', requestDraw, { passive: true });
    window.addEventListener('pageshow', requestDraw);
    draw();

    active.set(root, () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', requestDraw);
      window.removeEventListener('resize', requestDraw);
      window.removeEventListener('pageshow', requestDraw);
      root.style.removeProperty('--oms-image-y');
      delete root.dataset.parallaxProgress;
      delete root.dataset.parallaxActive;
    });
  }

  function refresh() {
    for (const [root, destroy] of active) {
      if (!root.isConnected) {
        destroy();
        active.delete(root);
      }
    }
    document.querySelectorAll('[data-oms-root]').forEach(mount);
  }

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  document.addEventListener('shopify:block:select', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
